/** Public deck-card share links opened from Kakao / copy-link (guest-accessible). */

export const DECK_CARD_REDIRECT_URL_KEY = "deckCardRedirectUrl";

const DECK_CARD_SHARE_PATH =
  /^\/(single-card|demo-card|listening-together-card|season-card)\/[^/?#]+/;

const DECK_CARD_SHARE_FILTERS = new Set([
  "Single_Card",
  "Demo_Card",
  "Listening_Together_Card",
  "Season_Card",
  "Impact_Card",
]);

const isLobbyShareLocation = (pathname: string, search = ""): boolean => {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  if (normalized !== "/lobby") return false;

  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );

  return (
    params.has("userId") &&
    params.has("id") &&
    DECK_CARD_SHARE_FILTERS.has(params.get("filter") ?? "")
  );
};

export const isDeckCardSharePath = (pathname: string): boolean =>
  DECK_CARD_SHARE_PATH.test(pathname);

const isAppDeckShareLocation = (pathname: string, search = ""): boolean => {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  if (normalized !== "/app-deck") return false;

  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );

  return (
    params.has("userId") &&
    params.has("id") &&
    DECK_CARD_SHARE_FILTERS.has(params.get("filter") ?? "")
  );
};

/** Kakao / copy links include `userId` — triggers expand (front/back/details) flow. */
export const isDeckCardShareLink = (
  pathname: string,
  search = "",
): boolean => {
  if (isLobbyShareLocation(pathname, search)) return true;
  if (isAppDeckShareLocation(pathname, search)) return true;
  if (!isDeckCardSharePath(pathname)) return false;

  const params = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search,
  );
  return params.has("userId");
};

export const isPublicDeckCardShareLocation = isDeckCardShareLink;

export const isPublicDeckCardShareUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url, window.location.origin);
    return isDeckCardShareLink(parsed.pathname, parsed.search);
  } catch {
    return false;
  }
};

export const setDeckCardRedirect = (url: string): void => {
  localStorage.setItem(DECK_CARD_REDIRECT_URL_KEY, url);
};

export const storeDeckCardRedirectFromUrl = (url: string): void => {
  if (url.includes("/sign-in") || url.includes("/register")) return;
  if (!isPublicDeckCardShareUrl(url)) return;
  setDeckCardRedirect(url);
};

export const clearDeckCardRedirect = (): void => {
  localStorage.removeItem(DECK_CARD_REDIRECT_URL_KEY);
};

export const prepareDeckCardPostLoginRedirect = (): void => {
  clearDeckCardRedirect();
};
